var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3304,
    cy: 22.7914,
    r: 22.3304,
    fill: "#F3F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_16393)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1917,
    height: 26.1917,
    transform: "translate(9.19336 9.81055)",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1934 18.8105V23.8105C13.1934 27.5815 13.1944 29.4665 14.3654 30.6385C15.5364 31.8105 17.4224 31.8105 21.1934 31.8105H23.1934C26.9644 31.8105 28.8494 31.8095 30.0214 30.6385C31.1934 29.4675 31.1934 27.5815 31.1934 23.8105V18.8105M13.1934 18.8105H31.1934M13.1934 18.8105L14.0584 16.8875C14.7304 15.3955 15.0654 14.6505 15.7454 14.2305C16.4254 13.8105 17.2984 13.8105 19.0434 13.8105H25.3434C27.0884 13.8105 27.9604 13.8105 28.6414 14.2305C29.3214 14.6505 29.6564 15.3955 30.3284 16.8875L31.1934 18.8105M22.1934 18.8105V13.8105",
    stroke: "#2A00C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6934 24.3105H24.1934C24.7238 24.3105 25.2325 24.5213 25.6076 24.8963C25.9826 25.2714 26.1934 25.7801 26.1934 26.3105C26.1934 26.841 25.9826 27.3497 25.6076 27.7248C25.2325 28.0998 24.7238 28.3105 24.1934 28.3105H23.1934M20.1934 22.3105L18.1934 24.3105L20.1934 26.3105",
    stroke: "#2A00C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_16393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1917,
    height: 26.1917,
    fill: "white",
    transform: "translate(9.19336 9.81055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.90a3136b94f7f296ed80814fb036c718.svg";
export { ForwardRef as ReactComponent };